import { PATTER_ALPH } from "./constants";

const messageP1 = "Pendiente completar este campo.";
const messageObject = "Pendiente seleccionar una opción";
const emptyTypeDoc = "Elije primero un tipo de documento";
const messageDNI = "El número debe contener 8 dígitos.";
const messageEmail = "Ingresa un correo válido: “ejemplo@correo.com”.";
const messageText = "Solo letras (y signos que van con letras como tilde, diéresis, ñ, etc.)";
const messagePhone = "Debe ser menor o igual a 13 dígitos";
const messageNumber = "Solo números";
const messageDecimal = "Formato ejemplo: 150,350,000.00 (decimales separados por punto “.” y grupos de 3 cifras separadas por coma “,”)";
let valueType = "";

interface ValidationResult {
  error: boolean;
  message: string;
}

interface Request {
  typeDocument?: string;
  document?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  department?: string;
  province?: string;
  district?: string;
  queryType?: string;
  message?: any;
  fullName?: string;
  departament?: string;
}

export const isEmptyString = (value: any): boolean => {
  return value == undefined || value == null || value === "" || value === "";
};

export const isEmptyObject = (value: any): boolean => {
  return value == null || value == undefined || Object.keys(value).length === 0;
};

export const validateFieldString = (value: any): ValidationResult => {
  return {
    error: isEmptyString(value),
    message: messageP1,
  };
};

export const validateFieldObject = (value: any): ValidationResult => {
  return {
    error: isEmptyObject(value),
    message: messageObject,
  };
};

export const validateDocumentNumber = (value: string, typeDocument: string | undefined): ValidationResult => {
  if (typeDocument === null || typeDocument === undefined || typeDocument === "") {
    return {
      error: true,
      message: emptyTypeDoc,
    };
  }

  if (isEmptyString(value)) {
    return {
      error: true,
      message: messageP1,
    };
  }
  
  if (typeDocument === '01') {
    return {
      error: value.length !== 8,
      message: messageDNI,
    };
  }
  
  return {
    error: false,
    message: '',
  };
  
};

export const validateEmail = (value: string): ValidationResult => {
 /*  const regex = /^[0-9a-zA-Z_.]{0,50}@[a-zA-Z]{1,20}\.[a-zA-Z]{1,20}[a-zA-Z.]{0,5}$/; */
 const regex = /^[0-9a-zA-Z_.]{0,50}@[a-zA-Z.-]+\.[a-zA-Z]{2,}$/;

 
  if (isEmptyString(value)) {
    return {
      error: isEmptyString(value),
      message: messageP1,
    };
  } else {
    return {
      error: !regex.test(value),
      message: messageEmail,
    };
  }
};

export const completeForm = (request: Request): boolean => {
  if (isEmptyString(request.typeDocument)) {
    return false;
  }
  if (isEmptyString(request.document)) {
    return false;
  }
  if (isEmptyString(request.firstName)) {
    return false;
  }
  if (isEmptyString(request.lastName)) {
    return false;
  }
  if (isEmptyString(request.phone)) {
    return false;
  }
  if (validateEmail(request.email!).error) {
    return false;
  }
  if (isEmptyString(request.department)) {
    return false;
  }
  if (isEmptyString(request.province)) {
    return false;
  }
  if (isEmptyString(request.district)) {
    return false;
  }
  if (isEmptyString(request.queryType)) {
    return false;
  }
  if (isEmptyObject(request.message)) {
    return false;
  }
  return true;
};

export const validateForm = (request: Request): { complete: boolean } => {
  const complete = completeForm(request);

  return {
    complete: complete,
  };
};

export const completeFormDPF = (request: Request): boolean => {
  if (isEmptyString(request.fullName)) {
    console.log(1);
    return false;
  }

  if (isEmptyString(request.lastName)) {
    console.log(2);
    return false;
  }

  if (isEmptyString(request.document)) {
    console.log(3);
    return false;
  }

  if (isEmptyString(request.phone)) {
    console.log(4);
    return false;
  }
  if (validateEmail(request.email!).error) {
    console.log(5);
    return false;
  }
  if (isEmptyString(request.departament)) {
    console.log(6);
    return false;
  }
  if (isEmptyString(request.province)) {
    console.log(7);
    return false;
  }
  if (isEmptyString(request.district)) {
    console.log(8);
    return false;
  }
  return true;
};

export const validateFormDPF = (request: Request): { complete: boolean } => {
  const complete = completeFormDPF(request);

  return {
    complete: complete,
  };
};

export const validateText = (value: string): ValidationResult => {
  const regex = PATTER_ALPH;

  if (isEmptyString(value)) {
    return {
      error: isEmptyString(value),
      message: messageP1,
    };
  } else {
    return {
      error: !regex.test(value),
      message: messageText,
    };
  }
};

export const validatePhone = (value: string): ValidationResult => {
  const regex = new RegExp(/^\d*$/);

  if (isEmptyString(value)) {
    return {
      error: isEmptyString(value),
      message: messageP1,
    };
  }

  if (!regex.test(value)) {
    return {
      error: !regex.test(value),
      message: messageNumber,
    };
  }

  return {
    error: value.toString().split("").length > 13,
    message: messagePhone,
  };
};


export const validatePhoneOptional = (value: string): ValidationResult => {
  const regex = new RegExp(/^\d*$/);

  if (!regex.test(value)) {
    return {
      error: !regex.test(value),
      message: messageNumber,
    };
  } else {
    return {
      error: value.toString().split("").length > 13,
      message: messagePhone,
    };
  }
};

export const validateDecimal = (value: string): ValidationResult => {
  const regex = new RegExp(/^\d{1,3}(?:\d{1,3})?(?:\d{1,3})?(?:\.\d{1,2})?$/);
  if (value) {
    return {
      error: !regex.test(value),
      message: messageDecimal,
    };
  } else {
    return {
      error: false,
      message: "",
    };
  }
};

export const validateRequired = (value: string): ValidationResult => {
    if (isEmptyString(value)) {
        return {
          error: isEmptyString(value),
          message: messageP1,
        };
      } else {
        return {
          error: false,
          message: "",
        };
      }
    };
    
    export const patternTypeDocument = (typeDocument: { name: string } | undefined): RegExp => {
      if (typeDocument?.name === "DNI") {
        return /^(\d{0,8})$/g;
      }
    
      if (typeDocument?.name === "Pasaporte") {
        return /^([a-zA-Z]|\d){0,12}$/g;
      }
    
      if (typeDocument?.name === "Carné de Extranjería" || typeDocument?.name === "CEX" || typeDocument?.name === "Carné de Permiso Temporal de Permanencia" || typeDocument?.name === "PTP") {
        return /^(\d){0,12}$/g;
      }
    
      return /^.*$/g;
    };
